/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios';

/**
 * Alpine.js (bundled in Livewire) uses `instanceof ShadowRoot` without guarding
 * against missing globals. In some browsers or in-app webviews, ShadowRoot is
 * undefined and Livewire external scripts throw ReferenceError during init.
 * See TMAEX-4157.
 */
if (typeof globalThis.ShadowRoot === 'undefined' && typeof DocumentFragment !== 'undefined') {
    globalThis.ShadowRoot = class ShadowRoot extends DocumentFragment {};
}

window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// import Pusher from 'pusher-js';
// window.Pusher = Pusher;

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: import.meta.env.VITE_PUSHER_APP_KEY,
//     cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER ?? 'mt1',
//     wsHost: import.meta.env.VITE_PUSHER_HOST ? import.meta.env.VITE_PUSHER_HOST : `ws-${import.meta.env.VITE_PUSHER_APP_CLUSTER}.pusher.com`,
//     wsPort: import.meta.env.VITE_PUSHER_PORT ?? 80,
//     wssPort: import.meta.env.VITE_PUSHER_PORT ?? 443,
//     forceTLS: (import.meta.env.VITE_PUSHER_SCHEME ?? 'https') === 'https',
//     enabledTransports: ['ws', 'wss'],
// });

import * as Sentry from '@sentry/browser'

Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN_PUBLIC,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,

    // This enables automatic instrumentation (highly recommended), but is not
    // necessary for purely manual usage
    integrations: [Sentry.browserTracingIntegration()],
    release:import.meta.env.VITE_SENTRY_APP_NAME+"@"+import.meta.env.VITE_SENTRY_RELEASE,

    // To set a uniform sample rate
    tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE),

    enabled: import.meta.env?.VITE_SENTRY_ENVIRONMENT != 'local',

    // Filter out noise from third-party scripts we cannot fix site-side.
    ignoreErrors: [
        // Facebook / Instagram in-app browser native bridge failures (TMAEX-4062)
        /Error invoking postMessage/i,
        /Java exception was raised during method invocation/i,
        // Generic in-app browser bridge errors
        /Can't find variable: _AutofillCallbackHandler/i,
        /window\.webkit\.messageHandlers/i,
        // Hotjar survey-v2: HTMLDialogElement.showModal() throws InvalidStateError on Safari 16
        // when a dialog is already open or shown non-modally (e.g. during Livewire DOM updates).
        // See TMAEX-4094: InvalidStateError from survey-v2 on /postuler/offre/*
        /The object is in an invalid state/i,
        // Axeptio SDK (or similar widgets): a keyboard handler receives undefined
        // in a promise chain on iOS Safari → TypeError evaluating '*.code'.
        // Safari masks third-party script URLs as webkit-masked-url://hidden/.
        // See TMAEX-4172: onunhandledrejection on /offre/*, Mobile Safari iOS 18.
        /evaluating ['"].*\.code['"]/i,
        /Cannot read properties of undefined \(reading 'code'\)/i,
        // Safari iOS injects internal scripts (webkit-masked-url) that probe Apple Pay /
        // merchant state on non-payment pages. Not present in our codebase — see TMAEX-4208.
        "Can't find variable: merchant",
        /Can't find variable: merchant/,
        /refreshMerchantState/,
    ],
    denyUrls: [
        // Facebook in-app browser injected scripts
        /^iabjs:\/\//i,
        // Safari masked internal / injected script URLs
        /webkit-masked-url/,
        // Chrome / Safari / Edge extensions and other injected scripts we do not ship
        /^chrome-extension:\/\//i,
        /^moz-extension:\/\//i,
        /^safari-extension:\/\//i,
        /^safari-web-extension:\/\//i,
        // Hotjar tracking and survey widgets (survey-v2.js, etc.)
        /hotjar\.com/i,
        // Axeptio cookie consent widget (static.axept.io/sdk.js, client.axept.io/…)
        /axept\.io/i,
    ],
})
